import useAuth from './useAuth';
import { getLabHospital } from '../utils/labHospital';
import { LAB_ROLES } from '../utils/constants';

/**
 * The caller's laboratory context, from the `lab` block of the login /
 * profile payload. `can(perm | perm[])` — an array means ANY of them.
 *
 * A platform admin has every permission but must pick a hospital first;
 * `selectedHospitalId` is that choice (null until made).
 */
const useLab = () => {
  const { user, role, lab, can, isAdmin } = useAuth();
  const labRole = isAdmin ? 'manager' : lab?.lab_role || null;
  const selectedHospitalId = isAdmin ? getLabHospital() : null;

  const roleLabel =
    lab?.lab_role_label ||
    (isAdmin ? 'Platform Admin' : LAB_ROLES.find((r) => r.value === labRole)?.label || 'Lab Staff');

  return {
    role,
    enabled: isAdmin ? Boolean(selectedHospitalId) : Boolean(lab?.enabled),
    hospitalId: isAdmin ? selectedHospitalId : lab?.hospital_id || null,
    hospitalName: lab?.hospital_name || '',
    labRole,
    roleLabel,
    permissions: new Set(lab?.permissions || []),
    can,
    isAdmin,
    isManager: labRole === 'manager',
    isPhlebotomist: labRole === 'phlebotomist',
    needsHospital: isAdmin && !selectedHospitalId,
    userId: user?.id || user?.user_id || null,
  };
};

export default useLab;
